import MapRepository from "@domain/repositories/MapRepository";
import UseCase from "@domain/UseCase";
import { Map } from "@domain/models/Map";

type Input = Partial<Map>;

type Output = Promise<Map>;

export class CreateMapUseCase implements UseCase<Input, Output> {
  constructor(private readonly mapRepository: MapRepository) {}

  execute(data: Input) {
    return this.mapRepository.create(data);
  }
}
